<template>
  <div class="friendShip">
    <Tabbar :title="title" :enlishTitle="enlishTitle" :more="false"></Tabbar>
    <div class="friendShipList">
      <div v-for="item in picList" :key="item.id" class="friendShipList-block">
        <img :src="item.imageUrl" />
        <span @click="openLink(item.link)">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tabbar from './Tabbar.vue'
import { picList } from '../configs/config'

export default {
  data() {
    return {
      picList,
      title: '友情链接',
      enlishTitle: 'LINK OF FRIENDSHIP',
    }
  },
  mounted() {
  },
  components: {
    Tabbar,
  },
  methods: {
    openLink(link) {
      window.open(link)
    }
  },
}
</script>